/**
 * Labstep
 *
 * @module components/Tag/Action/Menu
 * @desc Action Menu for protocol
 */

import { TagActionDelete as DeleteTagAction } from 'labstep-web/components/Tag/Action/Delete';
import { TagActionEdit as EditTagAction } from 'labstep-web/components/Tag/Action/Edit';
import { TagActionViewAll } from 'labstep-web/components/Tag/Action/ViewAll';
import { ActionMenu } from 'labstep-web/core/Action/Menu';
import type React from 'react';
import type { ITagActionMenuProps } from './types';

export const TagActionMenu: React.FC<ITagActionMenuProps> = ({
  tag,
  actions = [],
}) => (
  <ActionMenu>
    {actions.includes('edit') && <EditTagAction tag={tag} />}
    {actions.includes('delete') && <DeleteTagAction tag={tag} />}
    {actions.includes('view_all') && <TagActionViewAll />}
  </ActionMenu>
);

TagActionMenu.defaultProps = {
  actions: [],
};
